var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommend-login"},[_vm._v(" 推荐好友 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }